import React, { useEffect, useState } from "react";
import {
  RequestsKeyHeaders,
  ImagePreviews,
  ButtonsWraper,
  NoprogramContainer,
  NoProgramContainer,
  NoProgramContainerInner,
  ProgramLoaderContainer,
  EmptyState,
  NoProgramText,
  NoProgramDescription,
  NoProgramButton,
} from "./style";
import { Context } from "../../../../../Store";
import callAPI from "../../../../../api/apiCaller";
import NoProgramImage from "../home-program.svg";
import Modal from "../../../../../common/Modal";
import NewRequestForm from "../NewRequest";
import {
  addHourToUnixTimeStamp,
  convertDateToCustomFormat,
} from "../../../../../common/utils";
import { useNavigate, useParams } from "react-router";
import Loading from "../../../../../common/Loading";
import { getUserInfo } from "../../../../../Store/User/accessors";
import {
  UpcomingCount,
  CompletedCount,
  UnacceptedCount,
  UpcomingTeamCount,
  CompletedTeamCount,
} from "../../../../../Store/ProgramMeetingCount/actions";
import EmptyStateImage from "./emptyState.png";
import AddProgram from "../../popups/AddProgram";
import { refreshProgramList } from "../../../../../Store/ProgramsList/actions";
import Meetings from "./Meetings";
import { useSearchParams } from "react-router-dom";
import Subscription from "../ProgramHome/Subscription";
import PaymentProcess from "../ProgramHome/PaymentProcess";

function ProgramOutBonds({
  isConnection,
  isUpcoming,
  isPast,
  currentTab,
  allProgramMeetingStatistics,
  specificProgramMeetingsStatistics,
  isTeam,
  isUnfulfilled,
  searchParticipant,
  dateRange,
  programTitle,
  refreshOnApply,
}) {
  const navigate = useNavigate();
  const params = useParams();
  const { dispatch, state } = React.useContext(Context);
  const [openNetworkProgramsMeetings, setOpenNetworkProgramsMeetings] =
    React.useState(null);
  const [openNetworkPrograms, setOpenNetworkPrograms] = React.useState([]);
  const [resetForm, setResetForm] = React.useState({});
  const [showForm, setShowForm] = React.useState(false);
  // const [isDeleteModal, setIsDeleteModal] = React.useState(false);
  const [isDeleteRequest, setIsDeleteRequest] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isCalenderDropdownActive, setIsCalenderDropdownActive] =
    useState(false);
  const [isCancelRequest, setIsCancelRequest] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();
  const [isProcess, setIsProcessing] = useState(null);
  const [disableButtonId, setDisableButtonId] = useState("");
  const userdata = getUserInfo(state);

  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [showAddProgram, setShowAddProgram] = useState(false);

  // New Start
  const [isPremiumOpen, setIsPremiumOpen] = React.useState(false);
  const [IsPaymentOpen, setIsPaymentOpen] = React.useState(false);
  const [plan, setPlan] = React.useState("");

  const [searchParams] = useSearchParams();

  const addProgram = searchParams.get("add-program") === "yes";

  const addProgramHandler = () => {
    if (userdata?.subscription?.id && !userdata?.subscription?.programId) {
      setShowAddProgram(true);
    } else {
      setIsPremiumOpen(!isPremiumOpen);
    }
  };

  useEffect(() => {
    if (
      userdata?.subscription?.id &&
      !userdata?.subscription?.programId &&
      userdata?.subscription?.plan === "Pro" &&
      addProgram
    ) {
      setShowAddProgram(true);
    }
  }, [userdata, addProgram]);
  // New Start End

  const [eventData, setEventData] = useState({
    eventName: "ICal",
    eventDescription: "This is a sample event description",
  });

  const downloadICS = (icsContent, filename) => {
    const blob = new Blob([icsContent]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const generateICS = (startDate, endDate, item) => {
    const isMyMente = item?.Mentor?.id === item?.user?.id;
    const { eventName, eventDescription } = eventData;
    //direct link to got calender meeting schedule
    const icsContent = `BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-// https://add-to-calendar-pro.com // button v2.4.3 //ENCALSCALE:GREGORIAN\nMETHOD:PUBLISH\nBEGIN:VEVENT\nUID:f4ab1cbb-b29d-4dee-83b1-e83cad00a26f\nDTSTAMP:20231009T122014Z\nDTSTART;VALUE=DATE:${startDate}\nDTEND;VALUE=DATE:${endDate}\nSUMMARY:${
      item.program?.title
    } meeting with ${
      isMyMente ? item.meeting.user.firstName : item.Mentor.firstName
    }\nSEQUENCE:0\nSTATUS:CONFIRMED\nCREATED:20231009T122003Z\nLAST-MODIFIED:20231009T122003Z\nEND:VEVENT\nEND:VCALENDAR`;
    downloadICS(icsContent, `${eventName}.ics`);
  };
  const formatDateTime = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };
  const recipientId = params.connectionId;
  function getUpcommingMeetings() {
    const data = {
      id: params.selectedProgram,
      rid: recipientId,
      search:
        searchParticipant === undefined || searchParticipant?.trim() === ""
          ? null
          : searchParticipant,
      programTitle:
        programTitle === undefined || programTitle?.trim() === ""
          ? null
          : programTitle,
      fromCreatedAt: !dateRange?.from ? null : formatDateTime(dateRange?.from),
      toCreatedAt: !dateRange?.to ? null : formatDateTime(dateRange?.to),
    };
    !isTeam
      ? callAPI(
          dispatch,
          isUpcoming
            ? params.selectedProgram && recipientId
              ? "upCommingRequestsOneOnOne"
              : params.selectedProgram
              ? "upCommingRequests"
              : "upCommingForMyAllRequests"
            : params.selectedProgram && recipientId
            ? "pastRequestsOneOnOne"
            : params.selectedProgram
            ? "pastRequests"
            : "pastforAllRequests",
          data
        ).then((res) => {
          setOpenNetworkProgramsMeetings([]);
          if (res.isResponseOk) {
            if (!isUpcoming && !isUnfulfilled) {
              const filteredData = res.data.filter(
                (data) =>
                  data.meeting?.meetingScheduleDate || data?.meetingScheduleDate
              );
              filteredData.sort((a, b) => {
                const timestampA = new Date(a.meeting?.meetingScheduleDate);
                const timestampB = new Date(b.meeting?.meetingScheduleDate);
                return timestampB - timestampA;
              });
              setOpenNetworkProgramsMeetings(filteredData);
              dispatch(CompletedCount(filteredData.length));
            } else if (!isUpcoming && isUnfulfilled) {
              const filteredData = res.data.filter(
                (data) => data.meeting?.meetingScheduleDate === null
              );
              filteredData.sort((a, b) => {
                const timestampA = new Date(a.meeting?.createdAt);
                const timestampB = new Date(b.meeting?.createdAt);
                return timestampB - timestampA;
              });
              setOpenNetworkProgramsMeetings(filteredData);
            } else {
              setOpenNetworkProgramsMeetings(res.data);
              dispatch(UpcomingCount(res.data.length));
            }
          }
        })
      : callAPI(
          dispatch,
          isUpcoming ? "teamProgramMeetings" : "teamPastProgramMeetings",
          {
            id: params.selectedProgram,
            tid: params.connectionId,
          }
        ).then((res) => {
          setOpenNetworkProgramsMeetings([]);
          if (res.isResponseOk) {
            if (isUpcoming) {
              dispatch(UpcomingTeamCount(res.data.length));
            } else dispatch(CompletedTeamCount(res.data.length));
            setOpenNetworkProgramsMeetings(res.data);
          }
        });
  }

  useEffect(() => {
    if (!params.selectedProgram && !isTeam) {
      const data = {
        id: params.selectedProgram,
        rid: recipientId,
        search: searchParticipant?.trim() === "" ? null : searchParticipant,
        programTitle: programTitle?.trim() === "" ? null : programTitle,
        fromCreatedAt: !dateRange?.from
          ? null
          : formatDateTime(dateRange?.from),
        toCreatedAt: !dateRange?.to ? null : formatDateTime(dateRange?.to),
      };
      callAPI(dispatch, "upCommingForMyAllRequests", data).then((res) => {
        if (res.isResponseOk) {
          dispatch(UpcomingCount(res.data.length));
        }
      });
      callAPI(dispatch, "pastforAllRequests", data).then((res) => {
        if (res.isResponseOk) {
          if (!isUnfulfilled) {
            const filteredData = res.data.filter(
              (data) =>
                data.meeting?.meetingScheduleDate || data?.meetingScheduleDate
            );
            filteredData.sort((a, b) => {
              const timestampA = new Date(a.meeting?.meetingScheduleDate);
              const timestampB = new Date(b.meeting?.meetingScheduleDate);
              return timestampB - timestampA;
            });
            dispatch(CompletedCount(filteredData.length));
          } else {
            const filteredData = res.data.filter(
              (data) => data.meeting?.meetingScheduleDate === null
            );
            filteredData.sort((a, b) => {
              const timestampA = new Date(a.meeting?.createdAt);
              const timestampB = new Date(b.meeting?.createdAt);
              return timestampB - timestampA;
            });
            dispatch(UnacceptedCount(filteredData.length));
          }
        }
      });
    }
  }, [!params.selectedProgram]);

  useEffect(() => {
    if (isTeam) {
      callAPI(dispatch, "teamProgramMeetings", {
        id: params.selectedProgram,
        tid: params.connectionId,
      }).then((res) => {
        if (res.isResponseOk) {
          dispatch(UpcomingTeamCount(res.data.length));
        }
      });
      callAPI(dispatch, "teamPastProgramMeetings", {
        id: params.selectedProgram,
        tid: params.connectionId,
      }).then((res) => {
        if (res.isResponseOk) {
          dispatch(CompletedTeamCount(res.data.length));
        }
      });
    }
  }, [isTeam, params.connectionId, params.selectedProgram]);

  function reassignMentee(item) {
    setDisableButtonId(item.id);
    setIsLoading(true);
    callAPI(dispatch, "reassignMenteeAppHome", {
      id: item?.program?.id,
      mentorId: item?.Mentor?.participant[0]?.id,
      menteeId: item?.meeting?.user?.id,
      meetingId: item?.meeting?.id,
    }).then((res) => {
      setIsLoading(false);
      getUpcommingMeetings();
    });
  }

  function removeItemFromArray(itemToRemove) {
    const updatedArray = openNetworkProgramsMeetings.filter(
      (item) => item.meetingId !== itemToRemove
    );
    setOpenNetworkProgramsMeetings(updatedArray);
  }

  const handleAddToCalender = (item, type = "google") => {
    const isMyMente = item?.Mentor?.id === item?.user?.id;
    callAPI(dispatch, "AddtoCalendar", {
      id: item.id,
      addedToCalender: true,
    }).then(() => {});

    const startDate = convertDateToCustomFormat(
      item.meeting?.meetingScheduleDate
    );
    const endDate = convertDateToCustomFormat(
      addHourToUnixTimeStamp(item.meeting?.meetingScheduleDate)
    );
    if (type === "google") {
      const url = `https://calendar.google.com/calendar/u/0/r/eventedit?dates=${startDate}/${endDate}&text=${
        item.program?.title
      } meeting with ${
        isMyMente ? item.meeting.user.firstName : item.Mentor.firstName
      }`;
      window.open(url, "_blank");
    }
    if (type === "ical") {
      generateICS(startDate, endDate, item);
    }
    setIsCalenderDropdownActive((prev) => !prev);
    getUpcommingMeetings();
  };

  const handleCancelRequest = (item) => {
    return callAPI(dispatch, "cancelMeetingRequest", {
      id: item.meeting.id,
    }).then(() => {
      if (params.selectedProgram) {
        specificProgramMeetingsStatistics();
      } else {
        allProgramMeetingStatistics();
      }
      removeItemFromArray(item.meetingId);
    });
  };

  React.useEffect(() => {
    getUpcommingMeetings();
    // programs();
    // to render meeting count

    if (params.selectedProgram) {
      specificProgramMeetingsStatistics();
    } else {
      allProgramMeetingStatistics();
    }
    return () => {
      setOpenNetworkProgramsMeetings(null);
    };
  }, [currentTab, searchParticipant, refreshOnApply]);

  if (!isUpcoming && openNetworkProgramsMeetings === null && !isUnfulfilled) {
    return (
      <ProgramLoaderContainer>
        <Loading loadingItem="Completed Meetings" />
      </ProgramLoaderContainer>
    );
  } else if (
    !isUpcoming &&
    openNetworkProgramsMeetings === null &&
    isUnfulfilled
  ) {
    return (
      <ProgramLoaderContainer>
        <Loading loadingItem="Unaccepted Meetings" />
      </ProgramLoaderContainer>
    );
  } else if (openNetworkProgramsMeetings === null) {
    return (
      <ProgramLoaderContainer>
        <Loading loadingItem="Upcoming Meetings" />
      </ProgramLoaderContainer>
    );
  }
  if (openNetworkProgramsMeetings?.data?.length === 0 && isTeam) {
    getUpcommingMeetings();
    return (
      <NoprogramContainer>
        <RequestsKeyHeaders size={13} widthSize={300} marginSpace={30}>
          You do not currently have any{" "}
          {isUpcoming ? "Upcoming" : isUnfulfilled ? "Unaccepted" : "Completed"}{" "}
          Team Meetings.
        </RequestsKeyHeaders>
        <ImagePreviews src={NoProgramImage} />
        <ButtonsWraper></ButtonsWraper>
      </NoprogramContainer>
    );
  }
  if (openNetworkProgramsMeetings.length === 0 && !isTeam) {
    return (
      <NoProgramContainer isProgram={!params.selectedProgram}>
        <NoProgramContainerInner isProgram={!params.selectedProgram}>
          <EmptyState src={EmptyStateImage} alt="Empty Meetings" />
          <NoProgramText>
            You do not currently have any{" "}
            {isUpcoming
              ? "upcoming"
              : isUnfulfilled
              ? "unaccepted"
              : "completed"}{" "}
            meetings.
          </NoProgramText>
          {!params.selectedProgram && (
            <>
              <NoProgramDescription>
                Click the button below to create new program.
              </NoProgramDescription>
              <NoProgramButton onClick={addProgramHandler}>
                Create a new Program
              </NoProgramButton>
            </>
          )}
        </NoProgramContainerInner>
        {/* New Start  */}
        {isPremiumOpen && (
          <Modal
            onClose={() => setIsPremiumOpen(false)}
            minWidth={"50vw"}
            isButtonCenter={true}
            isNotRound={true}
            hideBorder={true}
            isTask={true}
            isCreate={true}
            actions={[
              {
                text: "Cancel",
                onClick: () => {
                  setIsPremiumOpen(false);
                },
              },
            ]}
          >
            <Subscription
              setIsPremiumOpen={setIsPremiumOpen}
              setIsPaymentOpen={setIsPaymentOpen}
              setPlan={setPlan}
              setShowAddProgram={setShowAddProgram}
            />
          </Modal>
        )}

        {IsPaymentOpen && (
          <Modal
            onClose={() => setIsPaymentOpen(false)}
            minWidth={"50vw"}
            hideBorder={true}
            isButtonCenter={true}
            isNotRound={true}
            isTask={true}
            isCreate={true}
          >
            <PaymentProcess plan={plan} />
          </Modal>
        )}

        {showAddProgram && (
          <AddProgram
            closeModal={(shouldRefresh) => {
              if (shouldRefresh) {
                dispatch(refreshProgramList());
              }
              setShowAddProgram(false);
            }}
            isAddCreate={true}
          />
        )}
        {/* New Start End */}
      </NoProgramContainer>
    );
  }

  return (
    <>
      {isUpcoming ? (
        <Meetings
          openNetworkProgramsMeetings={openNetworkProgramsMeetings}
          params={params}
          navigate={navigate}
          // setIsDeleteModal={setIsDeleteModal}
          setSelectedMeeting={setSelectedMeeting}
          setShowForm={setShowForm}
          handleAddToCalender={handleAddToCalender}
          handleCancelRequest={handleCancelRequest}
          isUpcoming={isUpcoming}
          isConnection={isConnection}
          isUnfulfilled={isUnfulfilled}
          // isDeleteModal={isDeleteModal}
          isCancelRequest={isCancelRequest}
          setIsCancelRequest={setIsCancelRequest}
        />
      ) : isPast && openNetworkProgramsMeetings !== null ? (
        <Meetings
          isConnection={isConnection}
          openNetworkProgramsMeetings={openNetworkProgramsMeetings}
          params={params}
          navigate={navigate}
          // setIsDeleteModal={setIsDeleteModal}
          setSelectedMeeting={setSelectedMeeting}
          setShowForm={setShowForm}
          handleAddToCalender={handleAddToCalender}
          handleCancelRequest={handleCancelRequest}
          isPast={isPast}
          reassignMentee={reassignMentee}
          disableButtonId={disableButtonId}
          isLoading={isLoading}
          isUnfulfilled={isUnfulfilled}
          // isDeleteModal={isDeleteModal}
          isCancelRequest={isCancelRequest}
          setIsCancelRequest={setIsCancelRequest}
        />
      ) : (
        ""
      )}

      {showForm && (
        <Modal
          title={"Request a meeting"}
          onClose={() => setShowForm(false)}
          onOutsideClick={() => {}}
        >
          <NewRequestForm
            openNetworkPrograms={openNetworkPrograms}
            resetForm={resetForm}
            setResetForm={setResetForm}
            setShowForm={setShowForm}
            editForm={showForm}
            isEdit={true}
          />
        </Modal>
      )}
    </>
  );
}

export default ProgramOutBonds;
